import { useEffect } from 'react';
import { findLast } from 'lodash';
import { useIsTrackEnabled, useTrack, useMediaStreamTrack, useIsTrackSwitchedOn } from 'hooks';
import useIsTrackSwitchedOff from './useIsTrackSwitchedOff';
import usePublications from './usePublications';

export default ({ participant, videoPriority = null }) => {
  const publications = usePublications(participant);
  const audioPublication = findLast(publications, (p) => p.kind === 'audio');
  const videoPublication = findLast(publications, (p) => !p.trackName.includes('screen') && p.kind === 'video');

  useEffect(() => {
    if (videoPublication) {
      if (videoPublication.setPriority && videoPriority) {
        videoPublication.setPriority(videoPriority);
      }
      return () => {
        if (videoPublication.setPriority && videoPriority) {
          // Passing `null` to setPriority will set the track's priority to that which it was published with.
          videoPublication.setPriority(null);
        }
      };
    }
  }, [videoPublication, videoPriority]);

  const videoTrack = useTrack(videoPublication);
  const audioTrack = useTrack(audioPublication);
  const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack);
  const isVideoEnabled = useIsTrackEnabled(videoTrack);
  const startedTrack = useMediaStreamTrack(videoTrack);
  const isSwitchedOn = useIsTrackSwitchedOn(videoTrack);
  return {
    videoTrack,
    audioTrack,
    mainVideoTrackEnabled: !isVideoSwitchedOff && isVideoEnabled && isSwitchedOn && !!startedTrack,
  };
};
